<app-banner
  [promotions]="bannerPromotions()"
  (ctaClicked)="learnMoreClicked(bannerPromotions)"
></app-banner>
<ama-ribbon
  [freidaNavigation]="freidaNavigation"
  [amaExploreMenuItems]="amaExploreMenuItems"
  [userMenuGroup]="userMenuGroup"
  [user]="user()"
  (userLogOut)="signOut()"
  (signInClicked)="signInButton()"
>
</ama-ribbon>
<app-navigation
  [menuItems]="$safeNavigationMigration(freidaNavigation?.[0])"
  tabindex="0"
></app-navigation>
<main role="main">
  <app-system-banner [promotions]="systemWideMessage()"></app-system-banner>
  <article role="article" class="content">
    <router-outlet></router-outlet>
  </article>
</main>
@if (isBrowser) {
  <app-toast position="top-center"></app-toast>

  <app-modal
    header="Session Timeout"
    [visible]="showIdleModal()"
    (visibleChange)="showIdleModal.set($event)"
  >
    <div class="idle-modal">
      <p class="idle-modal__message">Would you like to continue your session?</p>
      <div class="idle-modal__cta">
        <div class="half">
          <app-button label="YES" class="freida-primary-solid" (clicked)="stayLoggedIn()">
          </app-button>
        </div>
        <div class="half">
          <app-button
            label="NO"
            variant="secondary"
            class="freida-primary--outline"
            (clicked)="signOut()"
          >
          </app-button>
        </div>
      </div>
    </div>
  </app-modal>

  <app-modal
    header="Session Expired"
    [visible]="showUserLoggedOutModal()"
    (afterClose)="onUserLoggedOutModalClosed()"
  >
    <div class="expired-modal">
      <p class="expired-modal__message">Your session has expired due to inactivity.</p>
      <div class="expired-modal__cta">
        <app-button label="Sign In" class="freida-primary-solid" (clicked)="signInButton()">
        </app-button>
      </div>
    </div>
  </app-modal>
}
<ama-footer ngSkipHydration [version]="version"></ama-footer>
